import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import Places from "./places/router"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/places`}>
        <Places base={`${base}/places`}/>
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
